export class SealContainer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, i: number) {
        
        super(scene);

        const sealImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "seal_" + i);
        this.add(sealImage);

        let text1Str: string;
        let text2Str: string;

        if(i === 1) {
            text1Str = "Покупка от 3 000 р.";
            text2Str = "1 дополнительное вращение";
        } else {
            text1Str = "Покупка от 20 000 р.";
            text2Str = "2 дополнительных вращения";
        }

        const text1 = new Phaser.GameObjects.Text(this.scene, 0, 245, text1Str, { fontFamily: "FuturaPTMedium", fontSize: "58px", color: "#FFE89B"});
        text1.setOrigin(.5)
        this.add(text1);

        const text2 = new Phaser.GameObjects.Text(this.scene, 0, 330, text2Str, { fontFamily: "FuturaPTBook", fontSize: "68px", color: "#FFE89B", align: "center"});
        text2.setOrigin(.5)
        this.add(text2);
    }
}